import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'

import pickoe from '../assets/images/shikakoe.png'
import pic01 from '../assets/images/pic01.png'
import picshogai from '../assets/images/shogai.png'
import picholmes from '../assets/images/holmes.png'
import picsmile from '../assets/images/smile.png'
import pichapi from '../assets/images/hapi.png'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Koutaka Portfolio"
                    meta={[
                        { name: 'description', content: 'Koutaka Portfolio' }
                    ]}
                >
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles" style={{backgroundColor:`#fff`}}>
                       <article style={{backgroundImage: `url(${pic01})`}}>
                            <header className="major">
                                <h3>Entertainment media site</h3>
                                <p>Wordpress,AWS</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pickoe})`}}>
                            <header className="major">
                                <h3>Medical media site</h3>
                                <p>Wordpress,rental server</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${picholmes})`}}>
                            <header className="major">
                                <h3>Smart contract system (SaaS)</h3>
                                <p>SPA,Java(Thymeleaf)</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${picshogai})`}}>
                            <header className="major">
                                <h3>Welfare web system</h3>
                                <p>ASP.net</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pichapi})`}}>
                            <header className="major">
                                <h3>Medical media site</h3>
                                <p>Wordpress,rental server</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${picsmile})`}}>
                            <header className="major">
                                <h3>Medical media site</h3>
                                <p>Wordpress,rental server</p>
                            </header>
                            <Link to="/portfolio" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>Portfolio</h2>
                            </header>
                            <p>I have a lot of experience in WordPress full customization, and I am in charge of a series of work from requirement definition to implementation. We support both back-end and front-end development including server construction.</p>
                            <ul className="actions">
                                <li><Link to="/portfolio" className="button next">Read More</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex